import { ref, watch } from 'vue';

const ELLIPSIS = '...';

export type PasteOverflowInfo = {
  pastedLength: number;
  resultLength: number;
  limit: number;
};

export function truncateToLimit(value: string, limit: number) {
  if (limit <= ELLIPSIS.length) {
    return value.slice(0, Math.max(limit, 0));
  }

  return value.slice(0, limit - ELLIPSIS.length) + ELLIPSIS;
}

export function usePasteOverflow() {
  const isOpen = ref(false);
  const info = ref<PasteOverflowInfo | null>(null);

  let resolveDecision: ((accepted: boolean) => void) | null = null;

  function settle(accepted: boolean) {
    const resolve = resolveDecision;

    resolveDecision = null;
    isOpen.value = false;
    resolve?.(accepted);
  }

  watch(isOpen, (open) => {
    if (!open) {
      settle(false);
    }
  });

  function confirm(value: PasteOverflowInfo) {
    settle(false);

    info.value = value;
    isOpen.value = true;

    return new Promise<boolean>((resolve) => {
      resolveDecision = resolve;
    });
  }

  return {
    isOpen,
    info,
    confirm,
    accept: () => settle(true),
    cancel: () => settle(false),
  };
}
